export default __webpack_public_path__ + "static/media/corner-4.62f4f1af.png";